export const VectorMode = {
  MAGNITUDE: 0,
  COMPONENT: 1,
  RGBCOLORS: 2,
};

export const ScalarMappingTarget = {
  LUMINANCE: 1,
  LUMINANCE_ALPHA: 2,
  RGB: 3,
  RGBA: 4,
};

export const Scale = {
  LINEAR: 0,
  LOG10: 1,
};

export default {
  VectorMode,
  ScalarMappingTarget,
  Scale,
};
